// Mutations del módulo Taxonomy.
// SET_EXPENDIOS_BY_CODIGO: único punto de escritura del mapa código->nombre
// para mantener reactividad y permitir reemplazo idempotente del estado.
const mutations = {
  SET_EXPENDIOS_BY_CODIGO(state, payload) {
    state.expendiosByCodigo = payload || {};
  },
};

export default mutations;
